import * as concept from "./concepts";
import * as user from "./users";
import * as pdfs from "./pdfs";

export default {
  concept,
  pdfs,
  user,
};
